// @ts-nocheck
/* eslint-disable */
export const flProhibitIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.63623 5.63599L18.3642 18.3639" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'prohibit' as const
};